export default __webpack_public_path__ + "static/media/delverypopup.7a218af3.jpg";